import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { User } from '../../../models/User';
import { UserService } from '../../../services/user.service';
import { Observable } from 'rxjs' ;

@Injectable()
export class CurrentUserResolver implements Resolve<User> {

    constructor(
        private userService: UserService
    ) { }

    resolve(): Observable<User> {
        return this.userService.getCurrentUser();
    }

}
